import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Tabs from '../../../components/Tabs';
import props from '../../../lib/contentLayoutProps/admissions/layoutProps';
import { getNavItem } from '../../../lib/nav';

const tabs = ['親子班', '幼稚園／幼兒園', '小學'];

const applyOnlineNavItem = getNavItem('admissions', 'apply-online');

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="zh" pageKey="how-to-apply">
        <h1>如何申請</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <h3>入學申請手續</h3>
            <p>
              京斯敦只接受網上申請。
              <a href={applyOnlineNavItem.url} target="_blank" rel="noopener noreferrer">
                請按此前往網上申請。
              </a>
            </p>
            <p>
              填寫好的申請表及相關文件經學校審閱後，校方會安排申請家庭於指定時間參觀本校校園，以了解日常上課情況。參觀期間，家長會會見幼稚園的管理層成員，一同討論孩子的背景、各方面的發展以及學校的理念和課程。
            </p>
            <p>本校會根據該學年的學額來決定取錄學生與否。學生一經取錄，校方會以書面形式通知家長。</p>

            <p>遞交網上申請表時，請連同以下文件：</p>
            <ul className="list">
              <li>出生証明副本</li>
              <li>防疫注射紀錄副本</li>
              <li>護照相片一張</li>
              <li>家長意見問卷</li>
            </ul>

            <h3>退學手續</h3>
            <p>
              辦理退學手續須於兩個月前（整月份計算）以書面形式正式通知校方，退學信請親身交回校務處，兩個月通知期內仍須繳交學費。如通知期不足兩個月，家長仍須繳交兩個月學費。
            </p>
            <p>
              <em>註：一個月指整月一號至該月底為止。</em>
            </p>
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <h3>入學申請手續</h3>
            <p>
              京斯敦只接受網上申請。
              <a href={applyOnlineNavItem.url} target="_blank" rel="noopener noreferrer">
                請按此前往網上申請。
              </a>
            </p>
            <p>
              填寫好的申請表及相關文件經學校審閱後，校方會安排申請家庭於指定時間參觀本校校園，以了解日常上課情況。參觀期間，家長會會見幼稚園的管理層成員，一同討論孩子的背景、各方面的發展以及學校的理念和課程。
            </p>
            <p>本校會根據該學年的學額來決定取錄學生與否。學生一經取錄，校方會以書面形式通知家長。</p>

            <p>遞交網上申請表時，請連同以下文件：</p>
            <ul className="list">
              <li>出生証明副本</li>
              <li>防疫注射紀錄副本</li>
              <li>護照相片一張</li>
              <li>以往的成績報告表(三歲及四歲班)</li>
              <li>家長意見問卷</li>
            </ul>

            <h3>退學手續</h3>
            <p>
              辦理退學手續須於兩個月前（整月份計算）以書面形式正式通知校方，退學信請親身交回校務處，兩個月通知期內仍須繳交學費。如通知期不足兩個月，家長仍須繳交兩個月學費。
            </p>
            <p>
              <em>註：一個月指整月一號至該月底為止。</em>
            </p>
          </React.Fragment>
        )}
        {tab === 2 && (
          <React.Fragment>
            <h3>入學申請手續</h3>
            <p>
              請透過本校的網上申請系統辦理入學申請。
              <a href={applyOnlineNavItem.url} target="_blank" rel="noopener noreferrer">
                請按此前往網上申請。
              </a>
            </p>
            <p>
              完成網上申請手續後，本校入學部將處理申請。如校方需要更多資料，將另行通知。面試包括英語、數學及普通話評核，口語評核將以英語及普通話進行。
              一年級面試於十一月及十二月進行，如有需要，會再於五月面試。建議家長於學期初完成申請，儘早進行面試。
            </p>
            <p>一年級面試以英語及普通話進行，重點評核學生的口語能力、社交技能及小肌肉活動能力。</p>
            <p>校方會儘早以書面公佈面試結果，結果分為錄取、候補或不錄取。</p>
            <p>如對入學申請手續有任何疑問，歡迎致電 2337 9031 或電郵 enquiry@kingston.edu.hk 與入學部聯絡。</p>

            <h3>退學手續</h3>
            <p>
              辦理退學手續須於三個月前（整月份計算）以書面形式正式通知校方，退學信請親身交回校務處，三個月通知期內仍須繳交學費。如通知期不足三個月，家長仍須繳交三個月學費。
            </p>
            <p>
              <em>註：一個月指整月一號至該月底為止。</em>
            </p>
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
